module.exports = "<div class=\"app-footer\">\n\n</div>"